import { useState } from 'react';
import './galeria.component.scss';
import GaleriaModel, { ItensGaleria } from '../../models/galeria.model';
import { Gallery } from "react-grid-gallery";
import Lightbox from "react-image-lightbox";
import "react-image-lightbox/style.css";
import { ComponentsModel } from '../../models/layout.model';

export type GaleriaComponentProps = {
  galeria?: GaleriaModel;
  itemSite: ComponentsModel;
}

function GaleriaComponent(props: GaleriaComponentProps) {

  const [index, setIndex] = useState(-1);

  const currentImage = props.galeria?.itens[index];
  const nextIndex = (index + 1) % (props.galeria ? props.galeria?.itens.length : 0);
  const nextImage = props.galeria?.itens[nextIndex] || currentImage;
  const prevIndex = (index + (props.galeria ? props.galeria?.itens.length : 0) - 1) % (props.galeria ? props.galeria?.itens.length : 0);
  const prevImage = props.galeria?.itens[prevIndex] || currentImage;

  const handleClick = (index: number, item: ItensGaleria) => setIndex(index);
  const handleClose = () => setIndex(-1);
  const handleMovePrev = () => setIndex(prevIndex);
  const handleMoveNext = () => setIndex(nextIndex);

  return (
    <section
      id={props.itemSite.galeria?.id}
      style={props.galeria?.bg ? { backgroundColor: props.galeria?.bg } : { backgroundColor: '#fff' }}
      className={"galeria"}>
      <div className="container">
        {
          props.galeria?.titulo &&
          <h2>{props.galeria?.titulo}</h2>
        }
        {
          props.galeria?.descricao &&
          <div className='txt'>{props.galeria?.descricao}</div>
        }
        <Gallery
          images={props.galeria ? props.galeria.itens : []}
          onClick={handleClick}
          enableImageSelection={false}
        />
      </div>

      {!!currentImage && (
        /* @ts-ignore */
        <Lightbox
          mainSrc={currentImage.src}
          imageTitle=''
          mainSrcThumbnail={currentImage.src}
          nextSrc={nextImage?.src}
          nextSrcThumbnail={nextImage?.src}
          prevSrc={prevImage?.src}
          prevSrcThumbnail={prevImage?.src}
          onCloseRequest={handleClose}
          onMovePrevRequest={handleMovePrev}
          onMoveNextRequest={handleMoveNext}
        />
      )}
    </section>
  );
}

export default GaleriaComponent;
